// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingView_container__twiVD","spinner":"LoadingView_spinner__k-VCL"};